import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Blocking screen for protected admin areas.
 *
 * Props:
 *   variant – 'login'  → visitor is not signed in yet, offers a login button
 *             'denied' → signed in but not an admin
 *   onLogin – click handler for the login button (variant 'login' only)
 */
export default function AccessDenied({ variant = 'denied', onLogin }) {
  const needsLogin = variant === 'login';

  return (
    <div className="min-h-[55vh] flex items-center justify-center px-4 py-20">
      <div className="max-w-md w-full text-center">
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gray-100 mb-6">
          <ShieldAlert className="w-6 h-6 text-gray-400" aria-hidden="true" />
        </span>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          {needsLogin ? 'Anmeldung erforderlich' : 'Zugriff verweigert'}
        </h1>
        <p className="text-gray-600 mb-8">
          {needsLogin
            ? 'Dieser Bereich ist nur für Administratoren zugänglich. Bitte melde dich mit einem Admin-Konto an.'
            : 'Dieser Bereich ist nur für Administratoren zugänglich.'}
        </p>
        <div className="flex items-center justify-center gap-3">
          {needsLogin && <Button onClick={onLogin}>Anmelden</Button>}
          <Button variant="ghost" asChild>
            <Link to="/">Zur Startseite</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}